import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { t } from 'i18next'
import { FormGroup } from 'reactstrap'
import DataTable from 'react-data-table-component'

import { customStyles } from '../../../izUtils'

const DictionaryList = ({data}) => {
    const Navigate = useNavigate()

    const handleRowClick = (state) => {
        Navigate('/dictionary/' + state.id + '/update')
    }

    const tableColumns = useMemo(() => {
        let columns = [
            {
                name: t('table.key'),
                selector: row => row.key,
                sortable: true,
            },
            {
                name: t('table.show'),
                selector: row => !row.hidden ? <i className="fa fa-check"></i> : <i className="fa fa-ban"></i>,
                sortable: true,
            },
        ];

        return columns;
    }, [data]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <FormGroup>
            <DataTable
                columns={tableColumns}
                data={data}
                customStyles={customStyles}
                onRowClicked={handleRowClick}
            />
        </FormGroup>
    )
}

export default DictionaryList